/* eslint-disable */

export const dashboardContent = {
  "data": {
    "amp_url": null,
    "api_url": "https://api.unbound-amsterdam.app/content-api/collections/dashboard/entries/0e802b1f-01d7-4306-9e8d-b2e833c57e26",
    "book_button_copy": "BOOK A TABLE",
    "collection": {
      "id": "dashboard",
      "title": "Dashboard",
      "api_url": null
    },
    "content": "<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exer citation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>",
    "date": "2020-09-07T12:47:29.000000Z",
    "edit_url": "https://api.unbound-amsterdam.app/cp/collections/dashboard/entries/0e802b1f-01d7-4306-9e8d-b2e833c57e26/did-you-know-our-restaurant-also-delivers",
    "enable_table_booking": true,
    "id": "0e802b1f-01d7-4306-9e8d-b2e833c57e26",
    "image": {
      "id": "images::onboarding/onboarding-step-1@2x.jpg",
      "url": "https://api.unbound-amsterdam.app/storage/onboarding/onboarding-step-1@2x.jpg",
      "permalink": "https://api.unbound-amsterdam.app/storage/onboarding/onboarding-step-1@2x.jpg",
      "api_url": "https://api.unbound-amsterdam.app/content-api/assets/images/onboarding/onboarding-step-1@2x.jpg"
    },
    "is_entry": true,
    "last_modified": "2020-09-07T12:47:29.000000Z",
    "parent": null,
    "permalink": "https://api.unbound-amsterdam.app",
    "private": false,
    "published": true,
    "slug": "did-you-know-our-restaurant-also-delivers",
    "title": "Did you know our restaurant also delivers?",
    "updated_at": "2020-09-07T12:47:29.000000Z",
    "updated_by": {
      "id": 1,
      "name": "Edwin Fennema",
      "email": "edwin@lamalama.nl",
      "api_url": "https://api.unbound-amsterdam.app/content-api/users/1"
    },
    "uri": null,
    "url": "/"
  }
}
